import React, { useEffect, useRef } from 'react';

import * as S from './styles';
import { DataFormProps } from 'types/InputsStoriesCarouselProps';
import { shrinkText } from 'utils/functions';

interface FashionProps {
	storiesData: DataFormProps;
}

export default function Fashion({ storiesData }: FashionProps) {
	const listRef = useRef<HTMLDivElement>(null);
	const scrollSpeed = 1; // Ajuste a velocidade do scroll aqui

	//passa automaticamente para o lado o carrossel
	useEffect(() => {
		const list = listRef.current;
		if (!list) return;

		let scrollInterval: NodeJS.Timeout | null = null;

		const startScrolling = () => {
			if (scrollInterval) return;

			scrollInterval = setInterval(() => {
				if (list.scrollLeft + list.clientWidth >= list.scrollWidth) {
					list.scrollLeft = 0; // Reinicia o scroll quando chega ao final
				} else {
					list.scrollLeft += scrollSpeed;
				}
			}, 35);
		};

		const stopScrolling = () => {
			if (scrollInterval) {
				clearInterval(scrollInterval);
				scrollInterval = null;
			}
		};

		startScrolling();

		list.addEventListener('mouseenter', stopScrolling);
		list.addEventListener('mouseleave', startScrolling);

		return () => {
			stopScrolling();
			list.removeEventListener('mouseenter', stopScrolling);
			list.removeEventListener('mouseleave', startScrolling);
		};
	}, []);

	return (
		<S.container
			$pBottom={storiesData.paddingBottom}
			$pTop={storiesData.paddingTop}
		>
			<S.lisStories ref={listRef}>
				{storiesData.stories.map((item) => (
					<S.storie key={item.image.id} $isSquare={storiesData.square}>
						<img src={item.image.path} alt={item.title} />
						<p>{shrinkText(item.title, 8)}</p>
					</S.storie>
				))}
			</S.lisStories>
		</S.container>
	);
}
